import { render, staticRenderFns } from "./DigitalCard.vue?vue&type=template&id=25db0c56&scoped=true"
import script from "./DigitalCard.vue?vue&type=script&lang=js"
export * from "./DigitalCard.vue?vue&type=script&lang=js"
import style0 from "./DigitalCard.vue?vue&type=style&index=0&id=25db0c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25db0c56",
  null
  
)

export default component.exports